import React from 'react';
import propType from 'prop-types';
import {useSelector} from "react-redux";


const ListaIndividui = (props) => {

    const participantsToTheDate = useSelector(state => state.corso.participantsToTheDate);

    let __individui = props.arrayIndividui.filter(i => participantsToTheDate.map(p => p.idAnagrafica).includes(i.idAnagrafica));

    const doubleClickLeftToRight = (e) => {
        const individuoSelezionato = __individui[e.target.index];
        __individui.splice(e.target.index, 1);
        props.selectedIndividui.push(individuoSelezionato);

        props.listaIndividui(__individui, props.selectedIndividui);
    };

    //OK
    const moveOneLeftToRight = (e) => {
        e.preventDefault();
        if ((e.key === 'Enter' && e.target.id === 'selectAllIndividui') || e.target.id === 'moveOneLeftToRight') {
            const oldArrayIndividui = [...__individui];
            const getAllOptionAvailable = document.getElementById('selectAllIndividui').getElementsByTagName('option');

            const selectItem = Array.from(getAllOptionAvailable).filter(option => {
                return (option.selected)
            }).reduce((el1, el2) => {
                el1.push(oldArrayIndividui[el2.index]);
                return el1
            }, []);

            selectItem.forEach(el => __individui.splice(__individui.indexOf(el), 1));
            props.listaIndividui(__individui, [...props.selectedIndividui, ...selectItem]);
        }
    };

    //OK
    const moveAllLeftToRight = (e) => {
        e.preventDefault();

        const allIndividui = [...__individui, ...props.selectedIndividui];
        allIndividui.filter(i => !props.selectedIndividui.includes(i)).forEach(i => props.selectedIndividui.push(i));
        allIndividui.filter(i => __individui.includes(i)).forEach(i => __individui.splice(__individui.indexOf(i), 1));

        props.listaIndividui(__individui, props.selectedIndividui);

    };

    //OK
    const doubleClickRightToLeft = (event) => {

        const individuoSelezionato = props.selectedIndividui[event.target.index];
        props.selectedIndividui.splice(event.target.index, 1);
        __individui.push(individuoSelezionato);

        props.listaIndividui(__individui, props.selectedIndividui);
    };

    //OK
    const moveOneRightToLeft = (e) => {
        e.preventDefault();
        if ((e.key === 'Enter' && e.target.id === 'selectedIndividui') || e.target.id === 'moveOneRightToLeft') {
            const oldSelectedIndividui = [...props.selectedIndividui];
            const getAllOptionAvailable = document.getElementById('selectedIndividui').getElementsByTagName('option');

            const selectItem = Array.from(getAllOptionAvailable).filter(option => {
                return (option.selected)
            }).reduce((el1, el2) => {
                el1.push(oldSelectedIndividui[el2.index]);
                return el1
            }, []);

            selectItem.forEach(el => props.selectedIndividui.splice(props.selectedIndividui.indexOf(el), 1));
            __individui.push(...selectItem);
            props.listaIndividui(__individui, props.selectedIndividui);
        }
    };

    //OK
    const moveAllRightToLeft = (event) => {
        event.preventDefault();

        const allIndividui = [...__individui, ...props.selectedIndividui];

        allIndividui.filter(i => !__individui.includes(i)).forEach(i => __individui.push(i));
        allIndividui.filter(i => props.selectedIndividui.includes(i)).forEach(i => props.selectedIndividui.splice(props.selectedIndividui.indexOf(i), 1));

        props.listaIndividui(__individui, props.selectedIndividui);

    };

    const searchFunction = (target, type) => {
        const filter = target.value.toUpperCase();
        const optionSelectAllIndividui = (type === 'A') ? document.getElementById('selectAllIndividui').getElementsByTagName('option') : document.getElementById('selectedIndividui').getElementsByTagName('option');
        for (let i = 0; i < optionSelectAllIndividui.length; i++) {
            let option = optionSelectAllIndividui[i];
            if (option.textContent.toUpperCase().indexOf(filter) > -1) {
                optionSelectAllIndividui[i].style.display = '';
            } else {
                optionSelectAllIndividui[i].style.display = 'none';
            }
        }
    };

    const renderSelectedOption = () => {
        const selectedIndividui = [...props.selectedIndividui];
        return selectedIndividui.map((individuo, i) => (
            <option key={i} value={individuo.idAnagrafica}
                    onDoubleClick={doubleClickRightToLeft}
                    className='text-capitalize'>
                {individuo.cognome.toLowerCase()} {individuo.nome.toLowerCase()}
            </option>
        ))
    };


    const invalid = {
        width: '100%',
        marginTop: '.25rem',
        fontSize: '85%',
        color: '#dc3545'
    };

    return (
        <section className="row justify-content-around mt-4">
            <div className="col-12 col-md">
                <p className="text-center">
                    <strong>{props.label[0]} disponibili per la {props.label[1]}</strong>
                </p>
                <input type="text" placeholder="Search..." className="form-control mb-2"
                       onChange={({target}) => searchFunction(target, 'A')}/>
                <select id='selectAllIndividui'
                        className="form-control border border-secondary"
                        style={props.disabled ? {
                            overflow: 'auto',
                            cursor: 'not-allowed'
                        } : {overflow: 'auto'}}
                        multiple
                        size="10"
                        disabled={props.disabled}
                >
                    {__individui.length > 0 ? __individui.map((individuo, i) => {
                        return <option key={i}
                                       value={individuo.idAnagrafica}
                                       onDoubleClick={doubleClickLeftToRight}
                                       className='text-capitalize'
                        >
                            {individuo.cognome.toLowerCase()} {individuo.nome.toLowerCase()}
                        </option>
                    }) : null}
                </select>
            </div>
            <div className="d-flex flex-column align-content-center justify-content-center pt-md-4 pt-lg-4 pt-5">
                <button className="mb-1 mt-1 btn-sm btn-primary"
                        style={props.disabled ? {cursor: 'not-allowed', width: '80px'} : {width: '80px'}}
                        id="moveOneLeftToRight"
                        onClick={moveOneLeftToRight}
                        disabled={props.disabled}>&gt;</button>
                <button className="mb-1 btn-sm btn-primary"
                        onClick={moveAllLeftToRight}
                        style={props.disabled ? {cursor: 'not-allowed', width: '80px'} : {width: '80px'}}
                        disabled={props.disabled}>&gt;&gt;</button>
                <button className="mb-1 mt-3 btn-sm btn-primary"
                        id="moveOneRightToLeft"
                        onClick={moveOneRightToLeft}
                        style={props.disabled ? {cursor: 'not-allowed', width: '80px'} : {width: '80px'}}
                        disabled={props.disabled}>&lt;</button>
                <button className="mb-1 btn-sm btn-primary"
                        onClick={moveAllRightToLeft}
                        style={props.disabled ? {cursor: 'not-allowed', width: '80px'} : {width: '80px'}}
                        disabled={props.disabled}>&lt;&lt;</button>
                <br/>
            </div>
            <div className="col-12 col-md">
                <p className="text-center">
                    <strong>{props.label[0]} selezionati per la {props.label[1]}</strong>
                </p>
                <input type="text" placeholder="Search..." className="form-control mb-2"
                       onChange={({target}) => searchFunction(target, 'B')}/>
                <select multiple
                        size="10"
                        className={props.css.join(' ')}
                        id="selectedIndividui"
                        style={props.disabled ? {
                            overflow: 'auto',
                            cursor: 'not-allowed'
                        } : {overflow: 'auto'}}
                        disabled={props.disabled}
                >
                    {renderSelectedOption()}
                </select>
                {(props.invalid && props.touched && props.isRequired && props.css.includes('border-danger')) ?
                    <span style={invalid}>{props.feedback}</span> : null}
            </div>
        </section>
    )
};

export default ListaIndividui;

ListaIndividui.propType = {
    label: propType.string.isRequired,
    listaIndividui: propType.func.isRequired,
    cleanIndividui: propType.bool.isRequired,
    invalid: propType.bool.isRequired,
    touched: propType.bool.isRequired,
    isRequired: propType.bool,
    css: propType.arrayOf(propType.string),
    feedback: propType.string,
    arrayIndividui: propType.arrayOf(
        propType.shape({
            cognome: propType.string,
            id: propType.string,
            idAnagrafica: propType.string,
            idUniversale: propType.string,
            nome: propType.string,
            permessi: propType.arrayOf(propType.shape({valore: propType.string})),
            ruoli: propType.arrayOf(propType.shape({nome: propType.string}))
        })
    ).isRequired,
    selectedIndividui: propType.arrayOf({
        cognome: propType.string,
        id: propType.string,
        idAnagrafica: propType.string,
        idUniversale: propType.string,
        nome: propType.string,
        permessi: propType.arrayOf(propType.shape({valore: propType.string})),
        ruoli: propType.arrayOf(propType.shape({nome: propType.string}))
    }).isRequired
};

ListaIndividui.defaultProps = {
    listaIndividui: () => [],
    label: 'Allievi',
    cleanIndividui: false,
    invalid: false,
    touched: false,
    isRequired: false,
    css: [],
    feedback: '',
    arrayIndividui: [],
    selectedIndividui: []
};
